
<app-header
  class="fixed-header"
  [class.footer-page-header]="!showShellContent()"
  [isAuthenticated]="true"
  [profileName]="profileName"
  [profileBin]="profileBin"
  [profileType]="profileType"
  [menuItems]="currentMenuItems()"
  [enableNotifications]="true"
  [notificationModule]="notificationModule"
  [notificationDashboardRoute]="'/returns/initiate'"
  [notificationApiBaseUrl]="notificationApiBaseUrl"
  [notificationRequestTypes]="notificationRequestTypes"
  (logoutClicked)="onLogout()">
</app-header>

<app-loader *ngIf="isLoading()"></app-loader>

<div class="app-container">
  <div class="content-wrapper" [class.content-wrapper-full]="!showShellContent()">
    <div class="side-menu-wrapper" *ngIf="showShellContent()">
      <app-side-menu [subItems]="sideMenuItems"></app-side-menu>
    </div>
    <div class="main-content scrollable-main" [class.main-content-full]="!showShellContent()">
      <router-outlet></router-outlet>
      <app-login-logout *ngIf="showShellContent() && sessionReady"></app-login-logout>
      <app-rating *ngIf="showShellContent()"></app-rating>
    </div>
  </div>
</div>

<app-footer [pageMode]="false"></app-footer>
